module.exports = __webpack_public_path__ + "img/bottom.c41023f0.png";